import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { AuthProvider } from '@craft/shared'
import { onAuthChange, getUserData } from './lib/firebase'
import LandingPage from './pages/LandingPage'
import DashboardPage from './pages/DashboardPage'
import QuestionsPage from './pages/QuestionsPage'
import LearnWrapper from './pages/LearnWrapper'
import LegalPage from './pages/LegalPage'

export default function App() {
  return (
    <AuthProvider onAuthChange={onAuthChange} getUserData={getUserData}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/questions" element={<QuestionsPage />} />
          <Route path="/learn/:questionId" element={<LearnWrapper />} />
          <Route path="/legal" element={<LegalPage />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}
